import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const changeTransport = async ({ id, ...value }) => {
  return request.put(
    `/HousingStock/transport/${id}`,
    { ...value, id },
    'При привязки транспорта произошла ошибка',
    'Error'
  );
};

const useChangeTransport = (onSuccess) =>
  useMutation(changeTransport, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      if (typeof onSuccess === 'function') onSuccess();
    },
  });

export default useChangeTransport;
